import Component from "../../../../js/assets/component.js"
import WindowScroll from '../../../../js/assets/window_scroll.js'
import buttonLoadingEarth from "../../atoms/loading/loading_full_earth.js"

class TourDetailReserve extends Component{
  static get inquiryError400() { return 'ご希望出発日・ご希望人数での空席が確保できませんでした。' }
  static get inquiryError500() { return '申し訳ございません。空席情報が取得できませんでした。' }
  static get travelConditionCheckError() { return '「旅行条件書」及び「個人情報保護方針」への同意にチェックを入れてください。' }

  constructor(selector) {
    // set root element
    super(selector)
  }

  data() {
    return {
      "inquiryPriceUrl": '',
      "eccubeResponse": {},
      "bookingClass": "",
    }
  }

  adultParticipants() {
    return this.getNumber("#air-number-adult")
  }

  childrenParticipants(){
    return this.getNumber("#air-number-child")
  }

  infantParticipants(){
    return this.getNumber("#air-number-infant")
  }

  numberOfSingleRoom(){
    return this.getNumber("#number-of-single-room")
  }

  numberOfTwinRoom(){
    return this.getNumber("#number-of-twin-room")
  }

  getNumber(selector) {
    return Number(this.$el.find(selector).val())
  }

  airParticipants(){
    // 子供は座席を確保しない
    return this.adultParticipants() + this.childrenParticipants()
  }

  totalAllocations(){
    // 幼児は含めない
    return this.adultParticipants() + this.childrenParticipants()
  }

  roomParticipants() {
    return this.numberOfSingleRoom() * 1 + this.numberOfTwinRoom() * 2
  }

  isBalanceNumOfPeople() {
    return this.totalAllocations() === this.roomParticipants()
  }

  isExistParticipant() {
    // 大人がいないと申込み不可
    return this.adultParticipants() !== 0
  }

  isOverMinimumNumberOfApplication() {
    const min = parseInt(this.el.dataset.minimumNumberOfApplication)

    // 未登録のときはチェックしない
    if (isNaN(min)) {
      return true
    }

    return this.totalAllocations() >= min
  }

  // 飛行機内では、幼児は大人の膝の上にのせる。大人の数は幼児の数以上でなければならない。
  canHoldInfants() {
    return this.adultParticipants() >= this.infantParticipants()
  }

  isStockClassCalendar() {
    // "" or 1
    let bool = this.el.dataset.isStockClassCalendar
    return Boolean(bool)
  }

  isStockClassGds() {
    let bool = this.el.dataset.isStockClassGds
    return Boolean(bool)
  }

  isExistDepartureDate() {
    return Boolean(this.$el.find('#departure_date')[0].value)
  }

  availableSeatSearchRange() {
    return Number(this.el.dataset.availableSeatSearchRange)
  }

  isPermittedToChild() {
    return Boolean(this.el.dataset.isPermittedToChild)
  }

  isPermittedToInfant() {
    return Boolean(this.el.dataset.isPermittedToInfant)
  }

  // 子供申し込み不可のツアーに子供込で申し込んだらダメ
  considerPermissionToChild() {
    return this.isPermittedToChild() || this.childrenParticipants() === 0
  }

  // 幼児申し込み不可のツアーに幼児込で申し込んだらダメ
  considerPermissionToInfant() {
    return this.isPermittedToInfant() || this.infantParticipants() === 0
  }

  alertMessages(messages) {
    if (Array.isArray(messages)) {
      this.$el.find('.outOfStockAlert_content').first().html(messages.join("<br>"))
    } else {
      this.$el.find('.outOfStockAlert_content').first().text(messages)
    }

    this.$el.find('#outOfStockAlert').fadeIn()
  }

  // 料金計算APIに問い合わせる
  async inquirePrice() {
    let that = this
    let postData = {
      'departure_date': that.$el.find('#departure_date')[0].value,
      'air-number-adult': that.$el.find('#air-number-adult')[0].value,
      'air-number-child': that.$el.find('#air-number-child')[0].value,
      'air-number-infant': that.$el.find('#air-number-infant')[0].value,
      'number-of-single-room': that.$el.find('#number-of-single-room')[0].value,
      'number-of-twin-room': that.$el.find('#number-of-twin-room')[0].value,
    }

    // GDSのときは座席クラスを指定する
    if (this.isStockClassGds()) {

      // 例外処理
      if (!this.$data.bookingClass) {
        this.alertMessages(this.constructor.inquiryError500)
        return Promise.reject(new Error())
      }

      postData.booking_class = this.$data.bookingClass
    }

    let data

    try {
      data = await $.ajax({
        url: this.$data.inquiryPriceUrl,
        type: "GET",
        data: postData,
        dataType: 'json',
      })

      that.$data.eccubeResponse = data
      that.setPriceDetail()
      that.$el.find("#tourDetailReserve_tablePriceTotal").show()
    } catch (error) {
      console.error('料金計算でエラーが発生しました', error)
      if (error.status === 403) {
        // トークンが古くなっている可能性あり
        this.reloadPage()
        return
      }
      let messages = '在庫確認および料金取得に失敗しました。お手数ですが、時間をおいてお試し下さい。'
      if (error.responseJSON.messages) {
        messages = error.responseJSON.messages
      }
      that.alertMessages(messages)

      // 上に伝播させる
      throw error
    }

    return data
  }

  reloadPage() {
    console.log('時間経過のためトークン有効期限が切れている可能性があります、リロードします')

    const message = 'ページの有効期限が切れている可能性があります。5秒後にページをリロードします。'
    this.alertMessages(message)

    const url = new URL(window.location.href)
    url.searchParams.set('tab', "4")

    setTimeout(() => { window.location.assign(url.toString()) }, 5000)
  }

  // 一週間分の空席照会結果から、出発希望日の照会結果を取得する
  extractPreferredDateInfo(days) {
    // "yyyy/MM/dd"
    let dateString = this.$el.find('#departure_date')[0].value
    // phpからの返り値の形式に合わせ、時刻、タイムゾーン付き、スラッシュ区切りの形式でパースする。
    // "yyyy-MM-ddT00:00:00+09:00"
    let preferredDate = new Date(dateString.replace(/\//g, '-') + 'T00:00:00+09:00')
    this.isDate(preferredDate)

    return days.find((day) => {
      // タイムゾーン東京で、深夜0時の日付データがサーバーから返ってくる。
      // "yyyy-MM-ddT00:00:00+09:00"
      // 例: new Date('2019-06-14T00:00:00+09:00') => Mon Jun 14 2019 00:00:00 GMT+0900 (日本標準時)
      let scanningDate = new Date(day.day)
      this.isDate(scanningDate)
      return this.areSameDates(scanningDate, preferredDate)
    })
  }

  // 日付を比較する
  areSameDates(one, another) {
    return (one.getFullYear() === another.getFullYear()) &&
      (one.getMonth() === another.getMonth()) &&
      (one.getDate() === another.getDate())
  }

  // new Date()の結果が"Invalid Date"でないことを確認する
  isDate(date) {
    if (isNaN(date.getTime())) {
      console.error('日付のパースに失敗しました。', date)
    }
  }

  // GDS問い合わせ結果を検証する
  validateGdsResponse(day){
    let messages = []
    if (!day.is_enable) {
      messages.push(this.constructor.inquiryError400)
    }
    if (!day.is_exists) {
      messages.push(this.constructor.inquiryError500)
    }
    if (messages.length !== 0) {
      this.alertMessages(messages)
    }
    return messages.length === 0
  }

  dateToJapanese(date) {
    const kanjiWeeks = ['日', '月', '火', '水', '木', '金', '土']

    return (date.getMonth() + 1) + '/' + date.getDate() + ' (' + kanjiWeeks[date.getDay()] + ')'
  }

  yenFormat(yenPrice) {
    // IE11対応済み
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat/format#Browser_compatibility
    const formatter = new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency: 'JPY'
    })
    return formatter.format(yenPrice)
  }

  showPrice(price) {
    return price ? this.yenFormat(price) : ''
  }


  // GDSからのレスポンスを受け取り、一週間分表示する
  showMiniCalendar(days) {
    days.forEach((day, i) => { this.fillInMiniCalendarDay(day, i) })

    // 前後3日に空席があったら、ミニカレンダーを表示する
    if (this.canApplyForAnyOtherDays(days)) {
      this.$el.find(".departureCalendarMini").slideDown(300)
    }
  }

  fillInMiniCalendarDay(day, index) {
    let headerCell = this.$miniCalendar.find('.departureCalendarMini_date-' + index)
    headerCell.text(this.dateToJapanese(new Date(day.day)))

    if (this.canApply(day)) {
      this.fillInMiniCalendarPriceCell(day, index)
    } else {
      this.nullifyMiniCalendarCell(index)
    }
  }

  canApply(day) {
    return day.is_enable && day.is_exists
  }

  // 前後3日間に応募可能な日があるか
  canApplyForAnyOtherDays(days) {
    const today = this.extractPreferredDateInfo(days)
    const todayString = JSON.stringify(today)

    const otherDays = days.filter(day => JSON.stringify(day) !== todayString)

    return otherDays.some(day => this.canApply(day))
  }

  // ミニカレンダーに価格等の文言を入れる
  // 空席があるとき用のメソッド
  fillInMiniCalendarPriceCell(day, index) {
    let dateOfCell = new Date(day.day)

    // data attributesに日付データセット
    this.$miniCalendar.find('.departureCalendarMini_priceLink-' + index)[0].dataset.year = dateOfCell.getFullYear()
    this.$miniCalendar.find('.departureCalendarMini_priceLink-' + index)[0].dataset.month = ("00" + (dateOfCell.getMonth() + 1)).slice(-2)
    this.$miniCalendar.find('.departureCalendarMini_priceLink-' + index)[0].dataset.date = ("00" + dateOfCell.getDate()).slice(-2)

    // 大人価格をセット
    this.$miniCalendar.find('.departureCalendarMini_price-adult-' + index).text(this.showPrice(day.price))
    this.$miniCalendar.find('.departureCalendarMini_price-adult-' + index).addClass('departureCalendarMini_price')

    // 子供価格をセット
    let childText = "子供不可"
    if (day.child_price) {
      childText = this.showPrice(day.child_price)
    }
    this.$miniCalendar.find('.departureCalendarMini_price-child-' + index).text("(" + childText + ")")
    this.$miniCalendar.find('.departureCalendarMini_price-child-' + index).addClass('departureCalendarMini_price')

    // 幼児価格をセット
    let infantText = "幼児不可"
    if (day.infant_price) {
      infantText = this.showPrice(day.infant_price)
    }
    this.$miniCalendar.find('.departureCalendarMini_price-infant-' + index).text("(" + infantText + ")")
    this.$miniCalendar.find('.departureCalendarMini_price-infant-' + index).addClass('departureCalendarMini_price')

    // 価格が無いときの表示を隠す
    this.$miniCalendar.find('.departureCalendarMini_noPrice-' + index).hide()
  }

  // 席が空いていない日の表示
  nullifyMiniCalendarCell(index) {
    this.$miniCalendar.find('.departureCalendarMini_priceLink-' + index).removeData(['year', 'month', 'date'])
    this.$miniCalendar.find('.departureCalendarMini_price-adult-' + index).text('')
    this.$miniCalendar.find('.departureCalendarMini_price-adult-' + index).removeClass('departureCalendarMini_price')
    this.$miniCalendar.find('.departureCalendarMini_price-child-' + index).text('')
    this.$miniCalendar.find('.departureCalendarMini_price-child-' + index).removeClass('departureCalendarMini_price')
    this.$miniCalendar.find('.departureCalendarMini_price-infant-' + index).text('')
    this.$miniCalendar.find('.departureCalendarMini_price-infant-' + index).removeClass('departureCalendarMini_price')
    this.$miniCalendar.find('.departureCalendarMini_noPrice-' + index).show()
  }

  setBookingClass() {
    this.$el.find("#bookingClass").val(this.$data.bookingClass)
  }

  nullifyBookingClass() {
    this.$el.find("#bookingClass").val('')
  }

  // 空席照会および料金計算処理
  //
  // 1. GDS在庫管理ツアーの場合、空席問い合わせ
  //    エラー有れば表示して処理終了
  // 2. 料金計算問い合わせ。計算結果を表にセット
  //    エラー有れば表示して処理終了
  // 3. 結果表示
  //    料金明細を表示
  //    GDS在庫管理ツアーの場合、一週間分のミニカレンダー表示
  //    GDS在庫管理ツアーの場合、GDSの場合、最安値でなければ警告を表示
  async inquireAndCalculatePrice() {

    if (this.isStockClassGds()) {
      let gdsResponse

      try {
        gdsResponse = await this.inquireGdsPrice()
      } catch (e) {
        // inquireGdsPrice内で例外処理している
        // エラー起きたら終了
        return
      }

      this.showMiniCalendar(gdsResponse.days)

      // 当日の空席状況
      let preferredDateInfo = this.extractPreferredDateInfo(gdsResponse.days)
      if (!preferredDateInfo) {
        this.alertMessages('予期せぬエラーが発生しました。申し訳ございませんが、少したってから再度お試しいただけますようお願いいたします。')
        return
      }

      let isValid = this.validateGdsResponse(preferredDateInfo)

      // 問い合わせ日に空席なければ終了
      // 例外処理はvalidateGdsResponse()で行っている
      if(!isValid) {
        return
      }

      // 空席があるようなら料金計算APIに問い合わせる
      this.$data.bookingClass = preferredDateInfo.booking_class
      this.setBookingClass()
    }

    // 料金計算
    try {
      await this.inquirePrice()
    } catch (error) {
      console.error('料金計算でエラーが発生しました', error)
      return
    }
  }

  // GDS空席照会APIに問い合わせる
  async inquireGdsPrice() {
    let that = this
    let postData = {
      'product_id': Number(this.el.dataset.productId),
      'day': that.$el.find('#departure_date')[0].value,
      'count': that.airParticipants(),
    }

    that.nullifyBookingClass()

    let inquiryResult = {
      'days': [],
    }

    let range = this.availableSeatSearchRange();
    // 指定日前後もチェック
    for(let interval = -range; interval  <= range; interval++) {
      postData['interval'] = interval
      try {
        let responseOfADay = await $.ajax({
          url: that.el.dataset.inquiryOfGdsUrl,
          type: 'POST',
          data: postData,
          dataType: 'json'
        })
        if(responseOfADay.status !== "OK") {// status=NGは$.ajaxが例外を飛ばすが念の為
          throw responseOfADay.message
        }
        inquiryResult.days.push(responseOfADay.days[interval])
      } catch (error) {
        console.error('GDS照会に失敗しました', error)
        if (error.status === 403) {
          // トークンが古くなっている可能性あり
          this.reloadPage()
          return
        }
        that.alertMessages(this.constructor.inquiryError500)
        // 呼び出し元で検知できるように例外送出
        return Promise.reject(new Error())
      }
    }
    return inquiryResult
  }

  setPriceDetail() {
    this.setPriceDetailForHuman()
    this.setPriceDetailForProgramming()
  }

  setPriceDetailForHuman() {
    this.setRow('adult')
    this.setRow('child')
    this.setRow('infant')
    this.setRow('extraCharge')
    this.setRow('adultSurcharge')
    this.setRow('childSurcharge')
    this.setRow('airportTaxesOutsidePriceAdult')
    this.setRow('airportTaxesOutsidePriceChild')
    this.setRow('airportTaxesOutsidePriceInfant')
    this.setRow('airportTaxesPriceAdult')
    this.setRow('airportTaxesPriceChild')
    this.setRow('airportTaxesPriceInfant')
    this.setRow('airportTaxesInternationalTouristTax')
    this.setEstimated()
  }

  setPriceDetailForProgramming() {
    const response = this.$data.eccubeResponse
    this.$el.find('#tablePriceTotal_grandTotal').text(response.grand_total)

    this.$el.find('#adultNumber')[0].value = response.adult.number
    this.$el.find('#childNumber')[0].value = response.child.number
    this.$el.find('#infantNumber')[0].value = response.infant.number

    this.$el.find('#extraChargeNumber')[0].value = response.extraCharge.number
    this.$el.find('#adultSurchargeNumber')[0].value = response.adultSurcharge.number
    this.$el.find('#childSurchargeNumber')[0].value = response.childSurcharge.number
    this.$el.find('#airportTaxesOutsidePriceAdultNumber')[0].value = response.airportTaxesOutsidePriceAdult.number
    this.$el.find('#airportTaxesOutsidePriceChildNumber')[0].value = response.airportTaxesOutsidePriceChild.number
    this.$el.find('#airportTaxesOutsidePriceInfantNumber')[0].value = response.airportTaxesOutsidePriceInfant.number
    this.$el.find('#airportTaxesPriceAdultNumber')[0].value = response.airportTaxesPriceAdult.number
    this.$el.find('#airportTaxesPriceChildNumber')[0].value = response.airportTaxesPriceChild.number
    this.$el.find('#airportTaxesPriceInfantNumber')[0].value = response.airportTaxesPriceInfant.number
    this.$el.find('#airportTaxesInternationalTouristTaxNumber')[0].value = response.airportTaxesInternationalTouristTax.number

    this.$el.find('#adultPrice')[0].value = response.adult.price.replace(/,/g,"")
    this.$el.find('#childPrice')[0].value = response.child.price_system
    this.$el.find('#infantPrice')[0].value = response.infant.price_system

    this.$el.find('#extraChargePrice')[0].value = response.extraCharge.price.replace(/,/g,"")
    this.$el.find('#adultSurchargePrice')[0].value = response.adultSurcharge.price.replace(/,/g,"")
    this.$el.find('#childSurchargePrice')[0].value = response.childSurcharge.price.replace(/,/g,"")
    this.$el.find('#airportTaxesOutsidePriceAdultPrice')[0].value = response.airportTaxesOutsidePriceAdult.price.replace(/,/g,"")
    this.$el.find('#airportTaxesOutsidePriceChildPrice')[0].value = response.airportTaxesOutsidePriceChild.price.replace(/,/g,"")
    this.$el.find('#airportTaxesOutsidePriceInfantPrice')[0].value = response.airportTaxesOutsidePriceInfant.price.replace(/,/g,"")
    this.$el.find('#airportTaxesPriceAdultPrice')[0].value = response.airportTaxesPriceAdult.price.replace(/,/g,"")
    this.$el.find('#airportTaxesPriceChildPrice')[0].value = response.airportTaxesPriceChild.price.replace(/,/g,"")
    this.$el.find('#airportTaxesPriceInfantPrice')[0].value = response.airportTaxesPriceInfant.price.replace(/,/g,"")
    this.$el.find('#airportTaxesInternationalTouristTaxPrice')[0].value = response.airportTaxesInternationalTouristTax.price.replace(/,/g,"")
  }

  setRow(rowName) {
    let that = this
    let $table = this.$el.find('#tablePriceTotal')

    if (this.$data.eccubeResponse[rowName].display) {
      // これがないと、条件を変えて照会したときに、意図せず消えっぱなしの行が発生する
      $table.find(`#tablePriceTotal_${rowName}Row`).show()
    } else {
      $table.find(`#tablePriceTotal_${rowName}Row`).hide()
    }

    // 複数ヶ所登場
    $table.find(`.tablePriceTotal_${rowName}Row_number`).each(function(index){
      $(this).text(that.$data.eccubeResponse[rowName].number)
    })

    $table.find(`#tablePriceTotal_${rowName}Row_number_price`).text(this.$data.eccubeResponse[rowName].price)
    $table.find(`#tablePriceTotal_${rowName}Row_number_price_total`).text(this.$data.eccubeResponse[rowName].total)

  }

  // サーチャージが目安の時、注意書きを出す
  setEstimated() {
    if (this.$data.eccubeResponse.surcharge.isEstimated) {
      this.setEstimatedProviso()
      this.$el.find('#tablePriceTotal_estimatedProviso').show()
      this.$el.find('#tablePriceTotal_adultSurchargeRow_estimated').show()
      this.$el.find('#tablePriceTotal_childSurchargeRow_estimated').show()
    } else {
      this.$el.find('#tablePriceTotal_estimatedProviso').hide()
      this.$el.find('#tablePriceTotal_adultSurchargeRow_estimated').hide()
      this.$el.find('#tablePriceTotal_childSurchargeRow_estimated').hide()
    }
  }

  setEstimatedProviso() {
    let that = this
    this.$el.find('#tablePriceTotal_estimatedProviso_period').text(that.$data.eccubeResponse.surcharge.period)
    this.$el.find('#tablePriceTotal_estimatedProviso_estimatedDate').text(that.$data.eccubeResponse.surcharge.estimatedDate)
  }

  isValid() {
    return this.isExistDepartureDate() &&
           this.isExistParticipant() &&
           this.isBalanceNumOfPeople() &&
           this.isOverMinimumNumberOfApplication() &&
           this.considerPermissionToChild() &&
           this.considerPermissionToInfant() &&
           this.canHoldInfants()
  }

  errorMessages() {
    let messages = []

    if (!this.isExistDepartureDate()) {
      messages.push("ご出発日を選択してください。")
    }

    if (!this.isExistParticipant()) {
      messages.push("大人1人以上でお申し込みください。子供のみ、幼児のみ、子供と幼児のみではお申し込みできません。")
    }

    if (!this.isBalanceNumOfPeople()) {
      messages.push("ご搭乗人数と、お部屋数が合っていません。")
    }

    if (!this.isOverMinimumNumberOfApplication()) {
      messages.push(`本ツアーは${parseInt(this.el.dataset.minimumNumberOfApplication)}名様からのお申込みになります。`)
    }

    if (!this.considerPermissionToChild()) {
      messages.push('本ツアーにはお子様はご参加いただけません。')
    }

    if (!this.considerPermissionToInfant()) {
      messages.push('本ツアーには2歳未満のお子様はご参加いただけません')
    }

    if (!this.canHoldInfants()) {
      messages.push("幼児は、大人1人に対して1人までお申し込みできます。")
    }

    return messages
  }

  setDateToForm(year, month, date) {
    const inputFormToHuman = this.el.querySelector(".departureCalendar_selectedDepartureDate")
    const hiddenForm = this.el.querySelector("#departure_date")
    inputFormToHuman.value = `${year}年${month}月${date}日`
    hiddenForm.value = `${year}/${month}/${date}`
  }

  onFirstInquiry() {
    return this.$el.find('#tourDetailReserve_guide').fadeOut().promise()
  }

  async onClickInquiryButton() {

    await this.onFirstInquiry()

    // 再照会したとき用
    // awaitしないと、消えきる前にメッセージが入れ替わってしまう
    await this.backToNotInquired()

    if(!this.isValid()) {
      this.alertMessages(this.errorMessages())
    } else {
      this.buttonLoadingEarth.start()
      WindowScroll.preventScrollingBg()

      try {
        await this.inquireAndCalculatePrice()
      } catch (error) {
        // 起こらないはずだが念の為ロギング
        console.error('エラーが発生しました', error)
      }

      await this.buttonLoadingEarth.stop()
      WindowScroll.allowScrollingBg()
    }

    this.showResult()
  }

  // 未検索の状態に戻す
  backToNotInquired() {
    const resultPromise = this.$el.find('#tourDetailReserve_result').fadeOut().promise
    const alertPromise = this.$el.find('#outOfStockAlert').fadeOut().promise()
    const conditionPromise = this.onConditionChange()
    return Promise.all([resultPromise, alertPromise, conditionPromise])
  }

  // 照会条件変更時の制御
  // ト書き、料金明細、空席照会ボタンを押して下さい、という文言を出す。
  // エラーメッセージの表示は操作しない。バリデーションエラーメッセージを見ながら検索条件を変える、というケースがあると思うので。
  onConditionChange() {
    const totalPromise = this.$el.find("#tourDetailReserve_tablePriceTotal").fadeOut().promise()
    const miniCalendarPromise = this.$miniCalendar.fadeOut().promise()
    return Promise.all([totalPromise, miniCalendarPromise])
  }

  showResult() {
    this.$el.find('#tourDetailReserve_result').slideDown(300)
  }

  preventDoubleClick() {
    const $submitButton = this.$el.find("#tourDetailReserve_applyButton")

    // 追加したイベントハンドラを削除
    $submitButton.off('click')
    // aタグ本来の挙動(href="#"へ遷移)も防ぐ
    $submitButton.click(() => false)
  }

  scrollToNextQuestion() {
    const $nextInput = $('.airHotelsSelectBlock_air')
    const inputOffsetTop = $nextInput.offset().top
    const inputHeight = $nextInput.outerHeight()
    const marginHalf = ($nextInput.outerHeight(true) - inputHeight) / 2
    const windowHeight = $(window).height()

    const requiredScrollTop = inputOffsetTop - (windowHeight - inputHeight - marginHalf)

    const currentScrollTop = $(window).scrollTop()

    if (currentScrollTop >= requiredScrollTop) {
      return
    }

    $([document.documentElement, document.body]).animate({
      scrollTop: requiredScrollTop,
    }, {
      'duration': 1000,
    })
  }

  checkTravelConditions(){
    let isChecked = this.$el.find("#travelConditions_checkInput").prop('checked')
    return isChecked
  }

  // can access this.el or this.$el
  mounted() {
    //地球儀を全面に出すために挿入し直し
    $("body").append(this.buttonLoadingEarth.$el)

    this.$data.inquiryPriceUrl = this.el.dataset.inquiryPriceUrl
    this.inquiryButton = this.el.querySelector("#tour-detail-reserve-submit-button")
    this.$miniCalendar = this.$el.find('.departureCalendarMini').first()

    // 空席照会ボタンを押したときの制御
    this.inquiryButton.addEventListener("click", async (event) => {
      event.preventDefault()
      this.onClickInquiryButton().catch(e => console.error('rejected', e.reason, e))
    })

    // GDS照会時に出るミニカレンダーの日付をクリックしたときのイベントを設定する
    this.el.querySelectorAll(".departureCalendarMini_priceLink").forEach((priceCell) => {
      priceCell.addEventListener("click", (e) => {
        // 日付をセットして再照会
        this.setDateToForm(e.currentTarget.dataset.year, e.currentTarget.dataset.month, e.currentTarget.dataset.date)
        this.inquiryButton.click()
        e.preventDefault()
      }, false)
    })

    // 条件変更したときの処理
    // 日付は$.trigger('change')が期待通り動作しないため別途設定する
    const tourInputs = [
      // '#departure_date',
      '#air-number-adult',
      '#air-number-child',
      '#air-number-infant',
      '#number-of-single-room',
      '#number-of-twin-room',
    ]

    tourInputs.forEach((selector) => {
      let tourInput = this.el.querySelector(selector)
      tourInput.addEventListener('change', () => { this.onConditionChange() })
    })

    // 「お申込み手続きへすすむ」クリック時
    this.$el.find("#tourDetailReserve_applyButton").click((event) => {
      event.preventDefault()

      //旅行条件書の同意をチェック
      if(!this.checkTravelConditions()){
        this.alertMessages(this.constructor.travelConditionCheckError)
        return false
      }

      document.forms.tourContentForm.submit()

      this.preventDoubleClick()
    })

    // 日付をクリックしたときのイベントを設定する
    this.el.querySelectorAll(".departureCalender_monthTable .price").forEach((priceTag) => {
      priceTag.addEventListener("click", (e) => {
        // 照会結果を隠す、ページをスクロールする
        this.onConditionChange()
        this.scrollToNextQuestion()
        e.preventDefault()
      })
    })
  }
}

// export as singleton
let instance = new TourDetailReserve("#tourDetailReserve")
instance.buttonLoadingEarth = buttonLoadingEarth

// Object.seal(instance)
export default instance
